
import Util from "./Util"

export default class Config
{
	static Settings = {};

    /**
     * [Note]
     *
     * @param {String} key
     * @returns mixed
     */
    static get(key)
    {
    	if (!this.Settings) {
    		throw new Error(
    			"Config must boot w/ valid settings object before use"
    		);
    	}

        return Util.get(
            this.Settings, key
        );
    }

    /**
     * [Note]
     *
     * @param {Object} settings
     * @returns void
     */
    static boot(settings)
    {
        this.Settings = settings;
    }
}